<ng-template #step1>
  <div
    class="selfservice-ipp dialog__body dialog__body--grow dialog__body--scroll dialog__body--grey dialog__body--no-padding"
  >
    @if (saps()) {
      <div class="dialog__port-rule">
        <div class="dialog__port-number">{{ sapIndex() + 1 }}</div>
        <div style="flex-grow: 1">
          <div class="dialog__port-text">{{ portCustomerDescription() }}</div>
          <div class="dialog__port-subtext">
            {{ portSubscriptionId() | shorten_guid }} - {{ portCustomerFullname() }}, {{ portLocationCity() }} ({{
              portLocationStreet()
            }})
          </div>
        </div>
        @if (multiplePorts()) {
          <div class="selfservice-ipp__port-controls">
            <div class="selfservice-ipp__port-control" (click)="prevPort()">
              <svg-icon src="assets/images/icons/arrow-fill-down.svg"></svg-icon>
            </div>
            <div class="selfservice-ipp__port-control" (click)="nextPort()">
              <svg-icon src="assets/images/icons/arrow-fill-down.svg"></svg-icon>
            </div>
          </div>
        }
      </div>
    }

    <div class="selfservice-ipp__content">
      <div class="selfservice-ipp__content-left">
        <h4 class="selfservice-ipp__title">{{ "Selfservice.IPP.Available" | translate }}</h4>
        <div class="selfservice-ipp__search">
          <input
            type="text"
            [ngModel]="term()"
            (ngModelChange)="term.set($event)"
            class="searchTerm"
            placeholder="{{ 'Form.Placeholder.SearchIPPrefix' | translate }}"
          />
          <svg-icon src="assets/images/icons/search.svg"></svg-icon>
        </div>
        <div
          cdkDropList
          #availableList="cdkDropList"
          [cdkDropListData]="availableItems()"
          [cdkDropListConnectedTo]="[selectedList]"
          class="selfservice-ipp__list"
          (cdkDropListDropped)="drop($event)"
        >
          @for (item of filteredAvailableItems(); track $index) {
            <div
              class="selfservice-ipp__list-item"
              cdkDrag
              [cdkDragData]="item"
              [cdkDragDisabled]="item.subscriptionId === undefined"
            >
              <div class="selfservice-ipp__list-placeholder" *cdkDragPlaceholder></div>
              {{ item.ip_prefix.prefix }}
            </div>
          }
        </div>
      </div>
      <div class="selfservice-ipp__content-right">
        <h4 class="selfservice-ipp__title">{{ selectedItems.length }} {{ "Selfservice.IPP.Assigned" | translate }}</h4>
        <div
          cdkDropList
          #selectedList="cdkDropList"
          [cdkDropListData]="selectedItems"
          [cdkDropListConnectedTo]="[availableList]"
          class="selfservice-ipp__list"
          (cdkDropListDropped)="drop($event)"
        >
          @for (item of selectedItems; track $index) {
            <div
              class="selfservice-ipp__list-item"
              [class.selfservice-ipp__list-item--new]="!isOriginalItem(item.ip_prefix.prefix)"
              [cdkDragData]="item"
              cdkDrag
              [cdkDragDisabled]="item.subscriptionId === undefined"
              [matTooltipDisabled]="item.subscriptionId !== undefined"
              [matTooltip]="'Selfservice.IPP.Notyours' | translate"
              [matTooltipPosition]="'above'"
            >
              <div class="selfservice-ipp__list-placeholder" *cdkDragPlaceholder></div>
              @if (!item.subscriptionId) {
                <svg-icon src="assets/images/icons/lock.svg"></svg-icon>
              }
              {{ item.ip_prefix.prefix }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #step2>
  <div
    class="selfservice-ipp dialog__body dialog__body--grow dialog__body--scroll dialog__body--grey dialog__body--no-padding"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.IPP.Title" | translate }}</h3>
      <p class="no-margin t-newline">{{ "Selfservice.IPP.Text" | translate }}</p>
      @if (!matchPrefixes()) {
        <div class="dialog__error">{{ "Selfservice.IPP.Warning" | translate }}</div>
      }
      @if (!constraints()) {
        <div class="dialog__error">{{ "Selfservice.IPP.Error.AtLeastOne" | translate }}</div>
      }
      @if (didRemovePrefixes) {
        <div class="dialog__error">{{ "Selfservice.IPP.Warning.Remove" | translate }}</div>
      }
    </div>
    <div class="selfservice-ipp__summary">
      @for (sap of subscriptionCopy._saps; track $index; let i = $index) {
        <div class="selfservice-ipp__summary-item">
          <div class="selfservice-ipp__summary-top" (click)="expand(i)">
            <div class="selfservice-ipp__summary-left">
              <div class="selfservice-ipp__summary-number dialog__port-number">{{ i + 1 }}</div>
              <div class="selfservice-ipp__summary-text dialog__port-text">{{ sap.port?.description }}</div>
            </div>
            <div class="selfservice-ipp__summary-right">
              <ul class="selfservice-ipp__summary-right-list">
                <li>
                  <span>{{ "Selfservice.IPP.Total" | translate }}</span>
                  {{ sap.ip_prefixes.length }}
                </li>
                <li>
                  <span>{{ "Selfservice.IPP.New" | translate }}</span>
                  {{ countNewItems(sap.ip_prefixes, i) }}
                </li>
                <li>
                  <span>{{ "Selfservice.IPP.Removed" | translate }}</span> {{ removedItems(i).length }}
                </li>
              </ul>
              <svg-icon [class.active]="expandIndexes().includes(i)" src="assets/images/icons/chevron-down.svg">
              </svg-icon>
            </div>
          </div>
          @if (expandIndexes().includes(i)) {
            <div class="selfservice-ipp__summary-expand">
              @if (sap.ip_prefixes.length > 0) {
                <div class="selfservice-ipp__summary-expand-section">
                  <div class="selfservice-ipp__summary-subtitle">{{ "Selfservice.IPP.AssignedTwo" | translate }}</div>
                  <ul class="selfservice-ipp__summary-list">
                    @for (item of sortedPrefixes(sap.ip_prefixes); track $index) {
                      <li>
                        <div [class.new]="!isOriginalItemInSap(i, item.ip_prefix.prefix)">
                          {{ item.ip_prefix.prefix }}
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              }
              @if (removedItems(i).length > 0) {
                <div class="selfservice-ipp__summary-expand-section">
                  <div class="selfservice-ipp__summary-subtitle">{{ "Selfservice.IPP.RemovedTwo" | translate }}</div>
                  <ul class="selfservice-ipp__summary-list">
                    @for (item of removedItems(i); track $index) {
                      <li>
                        <div>
                          <svg-icon src="assets/images/icons/x.svg"> </svg-icon>
                          <span>{{ item.ip_prefix.prefix }}</span>
                        </div>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<selfservice-wizard
  [steps]="[step1, step2]"
  [getCommand]="buildCommand"
  [bus]="bus()"
  [canContinue]="!dataLoading()"
  [canConfirm]="constraints() && matchPrefixes()"
  [initialStep]="initialCurrentStep()"
/>
